/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  FaultInSiceTextureDetectionInfo,
  Horizon2DDetectionInfo,
  HorizonDetectionInfo,
  MlServiceType,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class MlCalcClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags MlCalc
   * @summary Метод отправки параметров расчета в ML
   * @request POST:/mlcalcAdapter/MlCalc/horizonDetection
   * @secure
   */
  mlCalcExecuteHorizonCalculation = (
    query: {
      /** Типы сервисов ML */
      mlServiceType: MlServiceType
    },
    data: HorizonDetectionInfo,
    params: RequestParams = {},
  ) =>
    this.http.request<string, string>({
      path: `/mlcalcAdapter/MlCalc/horizonDetection`,
      method: 'POST',
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags MlCalc
   * @summary Метод отправки параметров расчета в ML для 2D горизонтов
   * @request POST:/mlcalcAdapter/MlCalc/horizonDetection2d
   * @secure
   */
  mlCalcExecuteHorizon2DCalculation = (
    query: {
      /** Типы сервисов ML */
      mlServiceType: MlServiceType
    },
    data: Horizon2DDetectionInfo,
    params: RequestParams = {},
  ) =>
    this.http.request<string, string>({
      path: `/mlcalcAdapter/MlCalc/horizonDetection2d`,
      method: 'POST',
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags MlCalc
   * @summary Метод получения текстуры вероятности разлома
   * @request POST:/mlcalcAdapter/MlCalc/faultDetectionTexture
   * @secure
   */
  mlCalcGetFaultDetectionTexture = (
    query: {
      /** Типы сервисов ML */
      mlServiceType: MlServiceType
    },
    data: FaultInSiceTextureDetectionInfo,
    params: RequestParams = {},
  ) =>
    this.http.request<File, any>({
      path: `/mlcalcAdapter/MlCalc/faultDetectionTexture`,
      method: 'POST',
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'blob',
      ...params,
    })
}
